import { gridTpl } from '../../../../common/grid/grid.controller';

export const safetyPlanDocumentLocationsGrid = {
    bindings: {
        title: '@'
    },
    controller: 'SafetyPlanDocumentLocationsGridController',
    ...gridTpl
};

